/** Unified `/patient/...` URL search helpers (eval id resolution, query preservation). */
import { PATIENT_WORKSPACE_NEXT_CARE_PATHWAY_ID_QUERY } from '~/routes/paths';

/** Strips the legacy evaluation id query param while preserving other workspace search params. */
export function buildPatientWorkspaceSearchParamsExcludingEvalId(locationSearch: string): Record<string, string> {
  const searchParams: Record<string, string> = {};
  const query = locationSearch.startsWith('?') ? locationSearch.slice(1) : locationSearch;
  new URLSearchParams(query).forEach((value, key) => {
    if (key !== PATIENT_WORKSPACE_NEXT_CARE_PATHWAY_ID_QUERY) {
      searchParams[key] = value;
    }
  });
  return searchParams;
}

/**
 * Care-pathway evaluation record id from workspace URL state (legacy query, path segment, optional bootstrap).
 * Priority matches route canonicalization: query → route → bootstrap.
 */
export function resolveCarePathwayEvaluationIdFromWorkspaceLocation(input: {
  locationSearch: string;
  carePathwayEvaluationIdFromRoute?: string;
  bootstrapCarePathwayEvaluationId?: string;
}): string | undefined {
  const query = input.locationSearch.startsWith('?') ? input.locationSearch.slice(1) : input.locationSearch;
  const fromQuery = new URLSearchParams(query).get(PATIENT_WORKSPACE_NEXT_CARE_PATHWAY_ID_QUERY)?.trim();
  if (fromQuery) {
    return fromQuery;
  }
  const fromRoute = input.carePathwayEvaluationIdFromRoute?.trim();
  if (fromRoute) {
    return fromRoute;
  }
  return input.bootstrapCarePathwayEvaluationId?.trim() || undefined;
}
